export enum CtaButtonIdentifierEnum {
  back_to_invoice2go = 'back_to_invoice2go',
  sign_in = 'sign_in',
}

export const MOBILE_DEEPLINK = 'i2g://action/refresh_features';
export const VERIFY_ACCOUNT_COOKIE = 'verified';
